import { FC, ReactNode, useMemo, useState } from 'react'
import cn from './index.module.css'
import { tiptapValueEmpty } from '@/helpers/new/tiptapValueEmpty'
import { jsonConvert } from '@/helpers/jsonConvert'
import { Popover } from 'antd'
import TipTapView from '../TipTapView/TipTapView'
import ViewCourseTariffsModal from '@pages/CoursesCatalog/modals/ViewCourseTariffsModal/ViewCourseTariffs'
import { useGetSettings } from '@pages/CoursesCatalog/tabs/CatalogCoursesTab/hooks/getPlatformSettings'
import { usePlatformSettingsString } from '@/hooks/usePlatformSettingsString'

interface ICourseCard {
  course: ICourse
}

const CourseCard: FC<ICourseCard> = ({ course }) => {
  const freeEnrollText = usePlatformSettingsString(
    'isFreeEnrollButtonTitleChanged',
    'freeEnrollButtonTitle',
    'Записаться',
  )
  const [showTariffs, setShowTariffs] = useState<boolean>(false)
  const { checkSettings } = useGetSettings()
  const showDuration = checkSettings('catalog_displayCourseDurationInCard')
  const showOldPrice = checkSettings('catalog_showOldPrice')

  const getIcon = (course: ICourse): string | undefined => {
    const path = course?.mediaIcon?.path ?? course?.icon_path ?? undefined
    if (!path) return path
    if (path?.startsWith('blob')) {
      return path
    }
    return process.env.REACT_APP_PATH_FILE + path
  }

  function getLastChar(num: number): string {
    let str = num.toString()
    return str[str.length - 1]
  }

  const tiptapData = useMemo(
    () => jsonConvert(course.description),
    [course.description],
  )

  const isFree = useMemo(() => {
    return course.directionTariffs?.every((item) => item.type === 'free')
  }, [course.directionTariffs])

  const oldPrice =
    course?.old_price === null || course?.old_price === ''
      ? ''
      : Number(course?.old_price)?.toString()

  const onTariffsClick = () => {
    setShowTariffs(true)
  }

  return (
    <>
      <div className={cn.cardWrapper} onClick={onTariffsClick}>
        <div className={cn.cardHeader}>
          <div className={cn.nameRow}>{course?.name ?? ''}</div>
          <div className={cn.cardChipColumn}>
            {showDuration &&
              course?.duration_in_months &&
              course?.duration_in_months !== '' && (
                <div className={cn.chip}>
                  от {course?.duration_in_months ?? 0}{' '}
                  {getLastChar(Number(course?.duration_in_months) ?? 0) === '1'
                    ? 'месяца'
                    : 'месяцев'}
                </div>
              )}
            {!!Number(course.has_demo) && (
              <div className={cn.chip}>Есть демо-доступ</div>
            )}
          </div>
        </div>
        <div className={cn.content}>
          <div className={cn.iconRow}>
            <div className={cn.pricing}>
              <div className={cn.currentPrice}>
                {isFree
                  ? 'Бесплатно'
                  : `от ${Number(course?.start_price) ?? 0} р/мес`}
              </div>
              {showOldPrice && !isFree && oldPrice && (
                <div className={cn.oldPrice}>от {oldPrice} р/мес</div>
              )}
            </div>
            <img className={cn.icon} src={getIcon(course)} />
          </div>
        </div>
        <div className={cn.actions}>
          {!tiptapValueEmpty(tiptapData) && (
            <Popover
              overlayClassName={cn.popover}
              placement="bottom"
              title={course?.name ?? ''}
              content={<TipTapView value={course.description} />}
            >
              <button className={cn.moreButton}>Подробнее</button>
            </Popover>
          )}
          <button className={cn.tariffsButton} onClick={onTariffsClick}>
            {course?.directionTariffs?.length > 1 ? 'Тарифы' : isFree ? freeEnrollText : 'Купить'}
          </button>
        </div>
      </div>
      {course.id && (
        <ViewCourseTariffsModal
          visible={showTariffs}
          courseId={course.id}
          onDismiss={() => setShowTariffs(false)}
        />
      )}
    </>
  )
}

export default CourseCard
